import { useState } from 'react'
import { CustomRating } from './types'
import { TRUSTED_APPS_RATINGS_RECORD } from 'lib/records/modules/trustedAppsRatings'
import { updateRecord } from 'lib/records/workflows/updateRecord'

export const usePutRatings = () => {
  const [loading, setLoading] = useState(false)

  const putRatings = async (ratings: CustomRating[]) => {
    const saniRatings = ratings.reduce<Record<number, any>>((acc, r, i) => {
      acc[i] = {
        iconColor: r.iconColor as any,
        iconIdentifier: r.iconIdentifier,
        ratingId: r.isNew ? undefined : r.ratingId,
        ratingText: r.ratingText,
        isEmbedded: r.isEmbedded,
      }
      return acc
    }, {})

    try {
      setLoading(true)
      await updateRecord(TRUSTED_APPS_RATINGS_RECORD, '1', saniRatings, true)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }

    setLoading(false)
  }

  return [putRatings, loading] as const
}
